import React from 'react';
import plusIcon from "../../../svgs/plus-button.svg";
import minusIcon from "../../../svgs/minus-button.svg";

export default class BaseTabComponent extends React.Component {
    constructor(props) {
        super(props);
    }

    handleExpand() {
    }

    onTableValueChange(tableIdentifier, rowCode, event, columnIndex) {
    }

    static renderNameCell(row) {
        return (
            <td className='name-cell'>
                <span className='text'>{row.name}</span>
            </td>
        );
    }

    static renderStaticValueCell(tabs, cell, domKey, precomputedValues, rowIndex = null) {
        const displayValue = cell.getComputedValue(tabs, precomputedValues, rowIndex).displayValue;
        return (
            <td className={`${(displayValue === '-' ? 'center-dashes' : '')} value-cell ${(cell.styleClasses && cell.styleClasses.length ? cell.styleClasses : '')}`}
                key={domKey}>
                <span className='text value'>{displayValue}</span>
                {cell.tooltip ? <span className='cell-tooltip'>{cell.tooltip}</span> : null}
            </td>
        );
    }

    renderEditableValueCell(tableIdentifier, rowKey, row, columnIndex) {
        if (row.forceStatic) {
            return (
                <td className={`value-cell ${(row.styleClasses && row.styleClasses.length ? row.styleClasses : '')}`}
                    key={`${rowKey}-${columnIndex}`}>
                    {tableIdentifier === 'links' && (rowKey === 'google-maps-link' || rowKey.includes('tax-assessment-link')) && row.value ?
                        <a className='link' href={row.value} target='_blank'>{row.value}</a>
                        :
                        <span className='text value'>
                            {row.value && row.unit === '$' ? row.unit : null}
                            {row.value && row.unit === '$' ? BaseTabComponent.addCommasToNumber(row.value) : row.value}
                            {row.value && row.unit !== '$' ? (row.unit === 'Acres' || row.unit === 'SF' || row.unit === 'months' ? ` ${row.unit}` : row.unit) : null}
                        </span>                    }
                </td>
            );
        }

        return (
            <td className='value-cell editable-cell' key={`${rowKey}-${columnIndex}`}>
                {
                    row.type === 'dropdown' ?
                        <label>
                            <select
                                onChange={(event) => this.onTableValueChange(tableIdentifier, rowKey, event, columnIndex)}
                                value={row.value}>
                                <option value=''/>
                                {row.dropdownValues ? row.dropdownValues.filter(el => !el.isTerritory).map(elem =>
                                    <option key={elem.hasOwnProperty('abbr') ? elem.abbr : elem} value={elem.hasOwnProperty('abbr') ? elem.abbr : elem}>{elem.hasOwnProperty('name') ? elem.name : elem}</option>) : null}
                            </select>
                        </label>
                        :
                        <label
                            className={`${row.type} ${(row.type === 'number' && (row.unit === '$' || row.unit === '%' || row.unit === 'SF' || row.unit === 'Acres' || row.unit === 'Years' || row.unit === 'bps' || row.name === 'Total Sq Ft')) ? 'formatted-number-label' : ''}`}>
                            <input value={row.value}
                                   className={row.isWhite ? 'white' : ''}
                                   onChange={(event) => this.onTableValueChange(tableIdentifier, rowKey, event, columnIndex)}
                                   type={row.type !== 'date' ? row.type : null}
                                   placeholder={row.type === 'date' ? 'MM/DD/YYYY' : row.unit}/>
                            <div
                                className={'input-display-value ' + (row.isWhite ? 'white' : '')}>
                                {row.value && row.unit === '$' ? row.unit : null}
                                {row.value ?
                                    row.withDecimals ? Number(row.value).toFixed(2) : BaseTabComponent.addCommasToNumber(row.value)
                                    : null}
                                {row.value && row.unit !== '$' ? (row.unit === 'Acres' || row.unit === 'SF' ? ` ${row.unit}` : row.unit) : null}
                            </div>
                            {
                                tableIdentifier === 'links' &&
                                <a className="link-button" href={row.value} target="_blank">
                                    <svg aria-hidden="true" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                                        <path fill="currentColor" d="M576 24v127.984c0 21.461-25.96 31.98-40.971 16.971l-35.707-35.709-243.523 243.523c-9.373 9.373-24.568 9.373-33.941 0l-22.627-22.627c-9.373-9.373-9.373-24.569 0-33.941L442.756 76.676l-35.703-35.705C391.982 25.9 402.656 0 424.024 0H552c13.255 0 24 10.745 24 24zM407.029 270.794l-16 16A23.999 23.999 0 0 0 384 303.765V448H64V128h264a24.003 24.003 0 0 0 16.97-7.029l16-16C376.089 89.851 365.381 64 344 64H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V287.764c0-21.382-25.852-32.09-40.971-16.97z"/>
                                    </svg>
                                </a>
                            }
                        </label>
                }
            </td>
        );
    }

    static addCommasToNumber(number) {
        if (!number || !number.toString()) {
            return number;
        }
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    renderTable(tables, tableIdentifier, precomputedValues) {
        const table = tables[tableIdentifier];
        const tableRows = Object.keys(table.rows).map((key) => {
            const row = table.rows[key];
            const nameCell = BaseTabComponent.renderNameCell(row);
            let valueCell;
            if (row.editable) {
                valueCell = this.renderEditableValueCell(tableIdentifier, key, row);
            } else {
                valueCell = BaseTabComponent.renderStaticValueCell(this.props.tabs, row, null, precomputedValues, key);
            }
            return (
                <tr key={key} className={key}>{nameCell}{valueCell}</tr>
            );
        });

        return (
            <table className={`Financials_table ${tableIdentifier}-table`} key={tableIdentifier}>
                <tbody>{tableRows}</tbody>
            </table>
        )
    }

    renderMatrixTable(tables, tableIdentifier, precomputedValues, hasProformaExpansion = false) {
        const table = tables[tableIdentifier];

        const tableRows = Object.keys(table.rows).map((key) => {
            const row = table.rows[key];
            const nameCell = BaseTabComponent.renderNameCell(row);
            const rowKey = /(cam-[0-9])/g.test(key) ? key.split('-')[0] : key;

            return <tr key={key} className={rowKey}>
                {table.hasNamesColumn ? nameCell : null}

                {row.valueCells.map((cell, index) => {
                    if (cell === null) {
                        return <td key={index} className='invisible'/>
                    }
                    if (cell.hidden) {
                        return;
                    }
                    if (cell.editable) {
                        return this.renderEditableValueCell(tableIdentifier, key, cell, index);
                    } else {
                        const domKey = `${key}-${index}`;
                        return BaseTabComponent.renderStaticValueCell(this.props.tabs, cell, domKey, precomputedValues, key);
                    }
                })}
            </tr>
        });

        return (
            <div className='Financials_container' key={tableIdentifier}>
                <table className={`Financials_table ${tableIdentifier}-table`} key={tableIdentifier}>
                    <tbody>
                    {table.headerRow && table.headerRow.length ?
                        <tr>{table.headerRow.map((cell, index) => {
                            return (
                                <td className='header-cell' key={cell ? cell : index}>
                                    <div className='text'>{cell}</div>
                                </td>
                            )
                        })}</tr>
                        : null
                    }

                    {tableRows}

                    {table.footerRow && table.footerRow.valueCells && table.footerRow.valueCells.length ?
                        <tr className='footer-row'>{Object.keys(table.footerRow.valueCells).map((key) => {
                            const cell = table.footerRow.valueCells[key];
                            if (cell) {
                                return (
                                    <td key={key}>
                                        <div className='text'>{cell.getComputedValue(this.props.tabs, null, precomputedValues).displayValue}</div>
                                    </td>
                                );
                            }
                            return <td className='invisible' key={key}/>;
                        })}</tr>
                        : null
                    }
                    </tbody>
                </table>
                {
                    hasProformaExpansion &&
                    <div className={'Financials_table_expand_button'} dangerouslySetInnerHTML={{__html: (this.props.isProformaVisible ? minusIcon : plusIcon)}} onClick={(e) => this.handleExpand(e)}/>
                }
            </div>
        )
    }

    static renderTableContainer(mainTable, tablesToDisplay) {
        return (
            <div className='Financials_table_container'>
                {mainTable ?
                    <h3 className='Financials_table_title'>{mainTable.name}
                        <span className='Financials_table_description'>{mainTable.description}</span>
                    </h3>
                    : null}

                {tablesToDisplay.map((table) => table)}
            </div>
        )
    }


    static precomputeHeavilyUsedValues(tabs) {
        const precomputedValues = {};

        // Current RR Tab
        precomputedValues.totalSpace = tabs['current-rr-tab'].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs).internalValue;

        // Current Reimbursement Tab
        // precomputedValues.currentReimbursementInsurancePSF = tabs['current-reimbursement-tab'].tables['reimbursable-op-ex'].rows['insurance'].valueCells[7].getComputedValue(tabs).internalValue;

        // Pricing Tab
        precomputedValues.totalExpReimb = tabs['pricing-tab'].tables['exp-reimb'].footerRow.valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
        precomputedValues.totalExpenses = tabs['pricing-tab'].tables['expenses'].footerRow.valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
        precomputedValues.grossRentalRevenue = tabs['pricing-tab'].tables['base-rent'].footerRow.valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
        precomputedValues.effectiveGrossRevenue = tabs['pricing-tab'].tables['total-gross-revenue'].footerRow.valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
        precomputedValues.netOperatingIncome = tabs['pricing-tab'].tables['net-operating-income'].rows['net-operating-income'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
        precomputedValues.pricingValue = tabs['pricing-tab'].tables['value'].rows['value'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
        precomputedValues.requiredEquity = tabs['pricing-tab'].tables['required-equity'].rows['required-equity'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
        precomputedValues.cashFlow = precomputedValues.netOperatingIncome - tabs['pricing-tab'].tables['annual-debt-service'].rows['annual-debt-service'].valueCells[2].getComputedValue(tabs, precomputedValues).internalValue;
        precomputedValues.totalExpReimbProForma = tabs['pricing-tab'].tables['exp-reimb'].footerRow.valueCells[6].getComputedValue(tabs, precomputedValues).internalValue;
        precomputedValues.totalExpensesProForma = tabs['pricing-tab'].tables['expenses'].footerRow.valueCells[6].getComputedValue(tabs, precomputedValues).internalValue;
        precomputedValues.grossRentalRevenueProForma = tabs['pricing-tab'].tables['base-rent'].footerRow.valueCells[6].getComputedValue(tabs, precomputedValues).internalValue;
        precomputedValues.effectiveGrossRevenueProForma = tabs['pricing-tab'].tables['total-gross-revenue'].footerRow.valueCells[6].getComputedValue(tabs, precomputedValues).internalValue;
        precomputedValues.netOperatingIncomeProForma = tabs['pricing-tab'].tables['net-operating-income'].rows['net-operating-income'].valueCells[6].getComputedValue(tabs, precomputedValues).internalValue;
        precomputedValues.pricingValueProForma = tabs['pricing-tab'].tables['value'].rows['value'].valueCells[6].getComputedValue(tabs, precomputedValues).internalValue;
        precomputedValues.requiredEquityProForma = tabs['pricing-tab'].tables['required-equity'].rows['required-equity'].valueCells[6].getComputedValue(tabs, precomputedValues).internalValue;
        precomputedValues.cashFlowProForma = precomputedValues.netOperatingIncomeProForma - tabs['pricing-tab'].tables['annual-debt-service'].rows['annual-debt-service'].valueCells[6].getComputedValue(tabs, precomputedValues).internalValue;

        return precomputedValues;
    }


}